import * as R from 'ramda'
import type { Nil } from '@pbt/pbt-ui-components'

/** Width per attachment chip (label + margin) in px; must match MessageAttachment chip width. */
const ADJUSTED_CHIP_WIDTH_PX = 244 + 4
/** Width reserved for "Attachments" label and left spacing before the first chip. */
const LABEL_AND_LEADING_SPACE_PX = 91
/** Width reserved for the expand/collapse "more" button when at least one chip is visible. */
const EXPAND_BUTTON_WIDTH_PX = 95

export const getNumberOfHiddenItems = (
  attachmentCount: number,
  parentContainerWidth: number | Nil,
) => {
  const hiddenIndices: number[] = []

  if (parentContainerWidth) {
    R.times(R.identity, attachmentCount).forEach((index) => {
      const isLastAttachment = index + 1 === attachmentCount
      const reservedForButton = isLastAttachment ? 0 : EXPAND_BUTTON_WIDTH_PX
      const adjustedParentWidth =
        parentContainerWidth - LABEL_AND_LEADING_SPACE_PX - reservedForButton

      if (ADJUSTED_CHIP_WIDTH_PX * (index + 1) > adjustedParentWidth) {
        hiddenIndices.push(index)
      }
    })
    return hiddenIndices
  }

  return R.times(R.identity, attachmentCount)
}
